(function () {
  /* rb-copy-protect-v1 — raise friction for casual save/copy (not real DRM) */
  try {
    if (window.Shopify && Shopify.designMode) return;
  } catch (err) {}

  function isEditable(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
    if (el.isContentEditable) return true;
    if (el.closest && el.closest('input, textarea, select, [contenteditable="true"]')) return true;
    return false;
  }

  function isMedia(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 'img' || tag === 'picture' || tag === 'svg' || tag === 'video' || tag === 'canvas') {
      return true;
    }
    if (el.closest && el.closest('img, picture, svg, video, canvas, [style*="background-image"]')) {
      return true;
    }
    try {
      if (el.style && el.style.backgroundImage && el.style.backgroundImage !== 'none') return true;
    } catch (err2) {}
    return false;
  }

  document.addEventListener(
    'contextmenu',
    function (event) {
      if (isEditable(event.target)) return;
      event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      if (isEditable(event.target)) return;
      if (isMedia(event.target) || (event.target && event.target.tagName === 'A')) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'mousedown',
    function (event) {
      if (event.button === 1 && isMedia(event.target)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (isEditable(event.target)) return;
      var key = (event.key || '').toLowerCase();
      var meta = event.metaKey || event.ctrlKey;

      /* Save page / view source / print — common “grab a copy” shortcuts */
      if (meta && (key === 's' || key === 'u' || key === 'p')) {
        event.preventDefault();
        return;
      }

      /* Ctrl/Cmd+Shift+S (Save Page As in some browsers) */
      if (meta && event.shiftKey && key === 's') {
        event.preventDefault();
      }
    },
    true
  );

  var style = document.createElement('style');
  style.id = 'rb-copy-protect-css';
  style.textContent =
    'img, picture, svg, video, canvas, .rb-product__img, .rb-logo {' +
    '-webkit-user-drag:none!important;user-drag:none!important;' +
    '-webkit-touch-callout:none!important;' +
    '}' +
    'img, picture, .rb-product__img {' +
    'pointer-events:auto;' +
    '}';
  (document.head || document.documentElement).appendChild(style);
})();
